module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00011.cdc6b4d4.jpg",
  width: 3000,
  height: 2400,
  bytes: 618948,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00011.cdc6b4d4.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00011.jpg
// module id = 251
// module chunks = 0